<div class="container-fluid">
  <div class="row ">
    <div class="col-12 text- ">
      <h3 class="text-center" >{{ "accounts.activation_card_help.title" | translate }}</h3>
      <p>{{ "accounts.activation_card_help.text1" | translate }}</p>
      <h4>{{ "accounts.activation_card_help.text2" | translate }}</h4>
      <ul>
        <li>
          <span>{{ "accounts.activation_card_help.text3" | translate }}</span>
          <button class="btn btn-primary" (click)="goToHome()">{{ "accounts.activation_card_help.balance_button" | translate }}</button>
          <br>
        </li>

        <li>
          <span>{{ "accounts.activation_card_help.text4" | translate }}</span>
          <label>{{ "accounts.activation_card_help.text4_1" | translate }}</label><small class="ml-2 p-1 text-white card-not-active"><b>{{ "accounts.activation_card_help.text4_2" | translate }}</b></small>
          <span>{{ "accounts.activation_card_help.text4_3" | translate }}</span>
          <button class="btn btn-outline-primary" type="button"><i class="fas fa-eye"></i></button>
          <span>{{ "accounts.activation_card_help.text4_4" | translate }}</span>
        </li>

        <li>{{ "accounts.activation_card_help.text5" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text6" | translate }}</li>

        <li>{{ "accounts.activation_card_help.text7" | translate }}</li>
      </ul>
      <br><br>
      <h4>{{ "accounts.activation_card_help.text8" | translate }}</h4>
      <ul>
        <li>{{ "accounts.activation_card_help.text9" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text10" | translate }}.</li>
        <li>{{ "accounts.activation_card_help.text11" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text12" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text13" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text14" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text15" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text16" | translate }}</li>
        <li>{{ "accounts.activation_card_help.text17" | translate }}</li>
      </ul>
      <p class="">{{ "accounts.activation_card_help.text18" | translate }}</p>

    </div>
  </div>
  <div>
    <button class="btn btn-primary" (click)="goToHome()">{{ "accounts.activation_card_help.balance_button" | translate }}</button>
  </div>
</div>

